import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_BOILER',
  GET: 'GET_BOILER',
  CREATE: 'CREATE_BOILER',
  EDIT: 'EDIT_BOILER',
  DELETE: 'DELETE_BOILER',
  DUPLICATE: 'DUPLICATE_BOILER',
  CLEAR_ERROR: 'CLEAR_ERROR_BOILER',
};

export const clearErrorBoiler = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchBoilerByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchBoiler(pageSize, page, sorted, filtered, isPublic);
};

const searchBoiler = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_BOILER,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listBoiler = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchBoiler(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createBoiler = (name, efficiency, typeId, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('efficiency', efficiency);
  formData.set('type_id', typeId);
  formData.set('description', description);
  if (image) formData.set('image', image, `boiler_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_BOILER,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editBoiler = (id, name, efficiency, typeId, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (efficiency) formData.set('efficiency', efficiency);
  if (typeId) formData.set('type_id', typeId);
  if (typeof(description) === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `boiler_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_BOILER}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteBoiler = boilerId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_BOILER}${boilerId}/`,
    })
      .then(() => ({ id: boilerId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateBoiler = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_BOILER}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/boiler/boiler_actions.js